export default __webpack_public_path__ + "static/media/Website.25682e97.md";